import { useEffect, useState } from 'react';
import { useCredits } from './use-credits';
import { freeUsageEndsInMs, isFreeUsageActive } from './free-usage';

/**
 * The open free-usage window's end (ISO), or null when there is none. Re-renders at the moment the
 * window closes, so a page left open does not keep hiding the paywall after the free hours run out.
 */
export function useFreeUsageUntil(): string | null {
  const iso = useCredits().account?.freeUsageUntilIso ?? null;
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const delay = freeUsageEndsInMs(iso, Date.now());
    if (delay === null) return undefined;
    const timer = setTimeout(() => setTick((n) => n + 1), delay + 1);
    return () => clearTimeout(timer);
  }, [iso, tick]);
  return isFreeUsageActive(iso, Date.now()) ? iso : null;
}
